import { render, staticRenderFns } from "./DarkCirclesTemplate.vue?vue&type=template&id=88553734"
import script from "./DarkCirclesTemplate.vue?vue&type=script&lang=js"
export * from "./DarkCirclesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports